import { get } from 'lodash';
import { useQuery, NetworkStatus } from '@apollo/client';

import COMPANY_BILLING_DETAILED_QUERY from '../gql/CompanyBillingDetailedQuery.graphql';

const useDetailedBillingQuery = ({ fetchPolicy } = {}) => {
  const {
    loading,
    error,
    data,
    refetch,
    networkStatus,
    startPolling,
    stopPolling,
  } = useQuery(COMPANY_BILLING_DETAILED_QUERY, {
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
  });

  // get it, get it, get it
  const { plan, featureSet, ...company } = get(data, 'viewer.company', {});
  const availablePlans = get(company, 'availablePlans', []);
  const availableBillingPlans = get(data, 'viewer.billing.availablePlans', []);
  const subscription = get(data, 'viewer.billing.subscription', null);
  const activeAddOns = get(data, 'viewer.billing.activeAddons', []);
  const invoices = get(data, 'viewer.billing.invoices', []);
  const upcomingInvoice = get(
    data,
    'viewer.billing.subscription.upcomingInvoice',
    null,
  );
  const billableUsers = subscription?.billableUsers;

  return {
    loading,
    billableUsers,
    error,
    refetch,
    refreshing: networkStatus === NetworkStatus.refetch,
    currentPlan: plan,
    company,
    featureSet,
    availablePlans,
    availableBillingPlans,
    subscription,
    activeAddOns,
    invoices,
    upcomingInvoice,
    startPolling,
    stopPolling,
  };
};

export default useDetailedBillingQuery;
